import type { FC } from 'react';

export const InfoIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_196_1069)">
      <path
        d="M5 3.33333H5.00417M5 4.58333V6.66667M8.75 5C8.75 7.07108 7.07108 8.75 5 8.75C2.92893 8.75 1.25 7.07108 1.25 5C1.25 2.92893 2.92893 1.25 5 1.25C7.07108 1.25 8.75 2.92893 8.75 5Z"
        stroke={props.color || '#E6E6E9'}
        stroke-width="0.833333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_196_1069">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
